<template>
    <div class="inviteToRoom">
        <div class="inviteLinksWrapper">
            <div class="inviteLinks">
                <label>Room link:</label>
                <b-input-group>
                    <b-form-input @click="selectRoomLinkInput()" readonly id="roomLinkInput" :value="roomLink"></b-form-input>
                    <b-input-group-append>
                    <b-button v-if="isMobile" @click="shareLink()" variant="outline-secondary">            
                        <unicon name="share-alt" />
                    </b-button>
                    <b-button @click="copyRoomLink()" variant="outline-secondary">            
                        <unicon name="copy-alt" />
                    </b-button>
                    </b-input-group-append>
                </b-input-group>
            </div>
            <div :class="['inviteLinks',(!myRoomIdAlias)?'noRoomId':'']">
                <label>Room Id:</label>
                <b-input-group>
                    <b-form-input @click="selectRoomIdInput()" placeholder="Generating..." readonly id="roomIdInput" :value="myRoomIdAlias"></b-form-input>
                    <b-input-group-append>
                    <b-button @click="copyRoomId()" variant="outline-secondary">                        
                        <unicon name="copy-alt" />
                    </b-button>
                    </b-input-group-append>
                </b-input-group>
            </div>
        </div>
        <b-button variant="primary" size="sm">Invite friends</b-button>
    </div>
</template>
<script>
import store from '@/store'
import axios from 'axios'
export default {
    data:function(){
        return {
            roomId:this.$route.params.roomId,
            isMobile:(window.cordova)?true:false,
            roomLink:process.env.VUE_APP_URL+'/#/room/'+this.$route.params.roomId
        }
    },
    methods:{
        shareLink(){
            navigator.share("Join my bingo room and let's start the game \n"+process.env.VUE_APP_URL+'/room/'+this.$route.params.roomId);
        },
        selectRoomLinkInput(){
            var input = document.getElementById('roomLinkInput');
            input.select();
        },
        selectRoomIdInput(){            
            var input = document.getElementById('roomIdInput');
            input.select();
        },
        copyRoomLink(){
            this.selectRoomLinkInput();
            document.execCommand('copy');
            this.$toasted.show("Room link copied",{position:'top-center',duration:500,singleton:true});
        },
        copyRoomId(){
            if(!this.myRoomIdAlias){
                return;
            }
            this.selectRoomIdInput();
            document.execCommand('copy');
            this.$toasted.show("Room id copied",{position:'top-center',duration:500,singleton:true});
        }
    },computed:{
        myRoomIdAlias:()=>store.state.room.myRoomIdAlias
    },mounted:function(){
        axios.get(process.env.VUE_APP_SERVER_URL+'/getRoomAlias?roomId='+this.roomId)
        .then(function (response) {
            var roomIdAlias = response.data.roomIdAlias;
            store.state.room.myRoomIdAlias=roomIdAlias;
        });
    }
}
</script>